import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface ReportDeletedJobs {
    loading: boolean;
    startDate: string;
    endDate: string;
    errors: any;
}

export class ReportDeletedJobsData extends React.Component<RouteComponentProps<{}>, ReportDeletedJobs> {
    constructor(props: any) {
        super(props);

        this.state = {
            loading: true,
            startDate: "",
            endDate: "",
            errors: {}
        }  
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=RunReports&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                this.setState({ loading: false });
            } else if (res.data == false) {
                //redirect to 403 permission denied
                this.props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    handleChange = (e: any) => {
        let change: any = {};
        change[e.target.name] = e.target.value;
        change["errors"] = "";
        this.setState(change);
    }

    validate = () => {
        let fields = this.state;
        let errors: any = {};
        let formIsValid = true;

        if (!fields.startDate) {
            formIsValid = false;
            errors["startDate"] = "Start Date is required";
        }

        if (!fields.endDate) {
            formIsValid = false;
            errors["endDate"] = "End Date is required";
        }

        if (fields.startDate && fields.endDate && fields.endDate < fields.startDate) {
            formIsValid = false;
            errors["startDate"] = "Start Date must be < End Date";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    runReport = (e: any) => {
        e.preventDefault();
        //run the report and export the data

        if (this.validate()) {
            this.runRpt();
        }
    }

    async runRpt() {
        var url = "/report/DeletedJobsReport/" + this.state.startDate + "/" + this.state.endDate + "/-1/-1/-1";
        window.open(url, '_blank');
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {

        return (
            <div>
                <div>
                    <h1>Deleted Jobs Report</h1>
                </div>
                <div className="marginTop20">
                    <span>Select a Start Date and End Date to run the report. </span>
                </div>
                <div>
                    <label className="input-group" htmlFor="startDate">
                        <span className="label">Start Date</span>
                        <input type='date' id="startDate" name="startDate" className='input' value={this.state.startDate} onChange={(e) => this.handleChange(e)}></input>
                    </label>
                    <span className={this.state.errors["startDate"] ? "label errors marginLeftLabel" : "hidden"}>{this.state.errors["startDate"]}</span>

                    <label className="input-group" htmlFor="endDate">
                        <span className="label">End Date</span>
                        <input type='date' id="endDate" name="endDate" className='input' value={this.state.endDate} onChange={(e) => this.handleChange(e)}></input>
                    </label>
                    <span className={this.state.errors["endDate"] ? "label errors marginLeftLabel" : "hidden"}>{this.state.errors["endDate"]}</span> 
                </div>
                <button className="defaultbutton marginLeftLabel" type='button' onClick={this.runReport}>Run Report</button>
            </div>
        );

    }

};